/**
 * What the account orders page reads: each of the customer's orders with the five statuses they
 * see (ACC-020, FUL-030), never a pharmacy internal state. Type aliases rather than interfaces so
 * the Worker's `json()` accepts the payload.
 */
import { z } from "zod";
import type { CustomerOrderStatus } from "./machines.ts";

export type CustomerOrder = {
  readonly id: string;
  readonly status: CustomerOrderStatus;
  readonly placedAt: string;
  readonly trackingNumber: string | null;
  readonly trackingUrl: string | null;
};

export type CustomerOrders = {
  readonly orders: readonly CustomerOrder[];
};

const Status = z.enum(["received", "preparing", "shipped", "delivered", "attention"]);

const Order = z.object({
  id: z.string(),
  status: Status,
  placedAt: z.string(),
  trackingNumber: z.string().nullable(),
  trackingUrl: z.string().nullable(),
});

const List = z.object({ orders: z.array(Order) });

/** The account orders payload from a JSON body, or null when it is not one. */
export function readCustomerOrders(text: string): CustomerOrders | null {
  try {
    const parsed = List.safeParse(JSON.parse(text));

    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
